<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Influencers</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">Mit Trashed</option>
          <option value="only">Nur Trashed</option>
        </select>
      </search-filter>
      <inertia-link class="btn-green" :href="route('influencers.create')">
        <span>Erschaffen</span>
        <span class="hidden md:inline">Influencer</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Name</th>
          <th class="px-6 pt-6 pb-4">Nachname</th>
          <th class="px-6 pt-6 pb-4">Email</th>
          <th class="px-6 pt-6 pb-4">Telefonnummer</th>
          <th class="px-6 pt-6 pb-4">Adresse</th>
          <th class="px-6 pt-6 pb-4">PLZ</th>
          <th class="px-6 pt-6 pb-4">Ort</th>
          <th class="px-6 pt-6 pb-4">Kode</th>
          <th class="px-6 pt-6 pb-4">Kunden</th>
        </tr>
        <tr v-for="influencer in influencers.data" :key="influencer.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-kreditgenie-text-green" :href="route('influencers.edit', influencer.id)">
              {{ influencer.first_name }}
              <icon v-if="influencer.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('influencers.edit', influencer.id)" tabindex="-1">
              {{ influencer.last_name }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('influencers.edit', influencer.id)" tabindex="-1">
              {{ influencer.email }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('influencers.edit', influencer.id)" tabindex="-1">
              {{ influencer.phone }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('influencers.edit', influencer.id)" tabindex="-1">
              {{ influencer.address }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('influencers.edit', influencer.id)" tabindex="-1">
              {{ influencer.zip_code }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('influencers.edit', influencer.id)" tabindex="-1">
              {{ influencer.city }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('influencers.edit', influencer.id)" tabindex="-1">
              {{ influencer.influencer_code }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('influencers.edit', influencer.id)" tabindex="-1">
              <!--              {{ influencer.number_of_referrals }}-->
              <inertia-link
                class="ml-2 btn-green-small"
                :href="route('clients', {search: influencer.influencer_code})"
              >
                Offen
              </inertia-link>
            </inertia-link>
          </td>
          <td class="border-t" />
        </tr>
        <tr v-if="influencers.data.length === 0">
          <td class="border-t px-6 py-4" colspan="9">Keine Influencers gefunden.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="influencers.links" />
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import Icon from '../../Shared/Icon'

export default {
  metaInfo: { title: 'Influencers' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    influencers: Object,
  },

  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },

  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('influencers'), pickBy(this.form), { preserveState: true })
      }, 100),
    },
  },

  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },

  filters: {
    stripHTML: function(string) {
      return string.replace(/<\/?[^>]+>|&nbsp;/ig, ' ')
    },
  },

}
</script>
